import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class VendorContractHistoryResultDto {
    logId: number;
    action: string;

    @Type(() => UserNameDisplayResultDto)
    user: UserNameDisplayResultDto;

    @Type(() => Date)
    actionedOn: Date;
    data: string;
    additionalInformation: string;

    get userDisplayText(): string {
        return Utils.notNullAndDefined(this.user) ? this.user.displayName : '';
    }
}
